import { env as o } from "@fond-of/env";
const s = () => {
  if (o.isSSR)
    return {
      set: () => !0,
      get: () => null,
      delete: () => null
    };
  const e = {};
  return e.set = (t, r) => {
    try {
      window.localStorage.setItem(t, r);
    } catch {
      return !1;
    }
    return !0;
  }, e.get = (t) => window.localStorage.getItem(t), e.delete = (t) => {
    window.localStorage.removeItem(t);
  }, e;
}, n = () => {
  if (o.isSSR)
    return {
      set: () => !0,
      get: () => null,
      delete: () => null
    };
  const e = {};
  return e.set = (t, r) => {
    try {
      window.sessionStorage.setItem(t, r);
    } catch {
      return !1;
    }
    return !0;
  }, e.get = (t) => window.sessionStorage.getItem(t), e.delete = (t) => {
    window.sessionStorage.removeItem(t);
  }, e;
}, a = (e) => {
  switch (e) {
    case "localStorage":
      return s();
    case "sessionStorage":
      return n();
  }
}, g = {
  create: (e) => a(e)
};
export {
  g as Storage
};
//# sourceMappingURL=storage.js.map
